/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import SlickSlider from './components/slick';

$(document).ready(function () {
    createProductSpin();
    createInputFile();
    let slickSlider = new SlickSlider();
    $("#myModal .btn-primary").on('click', function (e) {
        e.preventDefault();
        $.ajax({
            url: 'module/seq_magasins/ajax',
            type: 'POST',
            cache: false,
            data: {
                ajax: true,
                action: 'removeCookies',
            },
            success: function () {
                return window.location.href = $("#myModal .btn-primary").attr("href");
            }
        });
    });
    $('.subheader-menu ul >li:first-child a').on('click', function () {
        $('#myModal').modal('show');
    });

    prestashop.on('updatedProduct', function (event) {
        createInputFile();


        if (event && event.product_minimal_quantity) {
            const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
            const quantityInputSelector = '#quantity_wanted';
            let quantityInput = $(quantityInputSelector);

            // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
            quantityInput.trigger('touchspin.updatesettings', {
                min: minimalProductQuantity
            });
        }
        $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
        $('.js-product-images-modal').replaceWith(event.product_images_modal);
        slickSlider.init();

    });


    function createInputFile() {
        $('.js-file-input').on('change', (event) => {
            let target, file;

            if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
                $(target).prev().text(file.name);
            }
        });
    }

    function createProductSpin() {
        const $quantityInput = $('#quantity_wanted');
        $quantityInput.TouchSpin({
            buttondown_class: 'btn js-touchspin',
            buttonup_class: 'btn js-touchspin',
            min: parseInt($quantityInput.attr('min'), 10),
            max: 1000000
        });
        $('body').on('change keyup', '#quantity_wanted', (e) => {
            $(e.currentTarget).trigger('touchspin.stopspin');
            prestashop.emit('updateProduct', {
                eventType: 'updatedProductQuantity',
                event: e
            });
        });

    }

});

$(document).on('shown.bs.modal', '#product-modal', function (e) {
    $('#js-slick-product').resize();
});


// $('.add-to-cart-seq .increaseQty').on('click', function (e) {
//     e.preventDefault();
//     updateProductQuantity($(this), "up");
// });
//
// $('.product-add-to-cart-seq .increaseQty').on('click', function (e) {
//     e.preventDefault();
//     updateProductPageQuantity($(this), "up");
// });
//
// $('.product-add-to-cart-seq .decreaseQty').on('click', function (e) {
//     e.preventDefault();
//     const elSeqQty = parseInt($(this).siblings('.qty-seq').text());
//     if (elSeqQty === 1) {
//         //delete product from cart
//         $(this).parent().attr('hidden', true);
//         $(this).parent().next().find('button[type="submit"]').removeAttr('hidden');
//         const url = $(this).parent().parent().find('input[name=url]').val();
//         const idProduct = $(this).parent().parent().find('input[name=id_product]').val();
//         const params = [];
//         params.push({
//             name: 'id_product',
//             value: idProduct
//         }, {
//             name: 'delete',
//             value: 1
//         });
//         $.ajax({
//             url: url,
//             type: "POST",
//             data: params,
//             success: function () {
//                 const quantityCartEl = $('.cart-products-count');
//                 const newQuantity = parseInt(quantityCartEl.text()) - 1;
//                 quantityCartEl.text(newQuantity);
//             },
//         });
//     } else {
//         updateProductPageQuantity($(this), "down");
//     }
// });
//
// $('.add-to-cart-seq .decreaseQty').on('click', function (e) {
//     e.preventDefault();
//     const elSeqQty = parseInt($(this).siblings('.qty-seq').text());
//
//     if (elSeqQty === 1) {
//         //delete product from cart
//         $(this).parent().attr('hidden', true);
//         $(this).parent().next().find('button[type="submit"]').removeAttr('hidden');
//
//         const form = $(this).parent().parent();
//         const actionUrl = form.attr('action');
//         let params = form.serializeArray();
//         params.push({
//             name: 'delete',
//             value: 1
//         });
//         $.ajax({
//             url: actionUrl,
//             type: "POST",
//             data: params,
//             success: function () {
//                 const quantityCartEl = $('.cart-products-count');
//                 const newQuantity = parseInt(quantityCartEl.text()) - 1;
//                 quantityCartEl.text(newQuantity);
//             },
//         });
//     } else {
//         updateProductQuantity($(this), "down");
//     }
// });
//
// $('.add-to-cart-seq button[type="submit"]').on('click', function (e) {
//     e.preventDefault();
//     const elSeqQty = $(this).parent().prev();
//     elSeqQty.removeAttr('hidden');
//     $(this).attr('hidden', true);
//     elSeqQty.find('.qty-seq').text("1");
// });
//
// $('.product-add-to-cart-seq button[type="submit"]').on('click', function (e) {
//     e.preventDefault();
//     const elSeqQty = $(this).parent().prev();
//     elSeqQty.removeAttr('hidden');
//     $(this).attr('hidden', true);
//     elSeqQty.find('.qty-seq').text("1");
// });
//
// function updateProductPageQuantity(thisEl, op) {
//     const elSeqQty = thisEl.siblings('.qty-seq');
//     const url = thisEl.parent().parent().find('input[name=url]').val();
//     const idProduct = thisEl.parent().parent().find('input[name=id_product]').val();
//     const params = [];
//     params.push({
//         name: 'id_product',
//         value: idProduct
//     }, {
//         name: 'update',
//         value: 1
//     }, {
//         name: 'action',
//         value: 'update'
//     }, {
//         name: 'op',
//         value: op
//     });
//     $.ajax({
//         url: url,
//         type: "POST",
//         data: params,
//         dataType: 'json',
//         success: function (retour) {
//             prestashop.emit('updateCart', {
//                 reason: {
//                     idProduct: retour.id_product,
//                     idProductAttribute: retour.id_product_attribute,
//                     idCustomization: retour.id_customization,
//                     linkAction: 'add-to-cart',
//                     cart: retour.cart
//                 },
//                 resp: retour
//             });
//             elSeqQty.text(parseInt(retour.quantity));
//         }
//     });
// }
//
// function updateProductQuantity(thisEl, op) {
//     const elSeqQty = thisEl.siblings('.qty-seq');
//     const form = thisEl.parent().parent();
//     const actionUrl = form.attr('action');
//     let params = form.serializeArray();
//     params.push({
//         name: 'update',
//         value: 1
//     }, {
//         name: 'action',
//         value: 'update'
//     }, {
//         name: 'op',
//         value: op
//     });
//     $.ajax({
//         url: actionUrl,
//         type: "POST",
//         data: params,
//         dataType: 'json',
//         success: function (retour) {
//             prestashop.emit('updateCart', {
//                 reason: {
//                     idProduct: retour.id_product,
//                     idProductAttribute: retour.id_product_attribute,
//                     idCustomization: retour.id_customization,
//                     linkAction: 'add-to-cart',
//                     cart: retour.cart
//                 },
//                 resp: retour
//             });
//             elSeqQty.text(parseInt(retour.quantity));
//         }
//     });
// }


// WEBPACK FOOTER //
// ./js/product.js